export const sortOrderTransform = (sortOrder) => {
  if(sortOrder == 'descending') return 'desc'

  return 'asc'
}
